import "../styles/globals.css";
import "../styles/ListVilla.css";
import StoreProvider from "../context/context";
import React from "react";
import "react-loading-skeleton/dist/skeleton.css";
import Header from "../static/Header.js";
import Structural from "../components/Structural.js";
import PageScripts from "../static/PageScripts.js";
import { TranslationProvider } from "../context/TranslationContext.js";

function MyApp({ Component, pageProps }) {
  return (
    <TranslationProvider>
      <StoreProvider>
        <Structural data={pageProps.data?.result.Structural} />
        <PageScripts
          ssr={pageProps.data}
          isAppWebView={pageProps.isAppWebView}
        />
        {pageProps.data?.RoutingAction != "SinglePayment" &&
        pageProps.data?.disableHeader != true ? (
          <Header
            headerContent={pageProps.data?.headerContent}
            isAppWebView={pageProps.isAppWebView}
          />
        ) : (
          ""
        )}
        <Component {...pageProps} />
      </StoreProvider>
    </TranslationProvider>
  );
}

export default MyApp;
